import React from "react";
import { FooterMessage } from "./Components/FooterMessage";
export const Footer = () => {
  return (
    <footer id="footer" className="footer wrapper items-center">
      <FooterMessage />
    </footer>
  );
};
